import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    disabled: _ctx.isLoading,
    class: _normalizeClass([{'active': _ctx.likedByMe}, "btn btn-like fw-bold ps-0"]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleLikedByMe && _ctx.toggleLikedByMe(...args)))
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["fa-thumbs-up", _ctx.thumbsClass]),
      "aria-hidden": "true"
    }, null, 2),
    _createTextVNode(" " + _toDisplayString(_ctx.numberOfLikes) + " ", 1),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "sr-only" }, "Likes erhalten", -1))
  ], 10, _hoisted_1))
}